import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import {
  Observable,
  OperatorFunction,
  Subject,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  merge,
} from "rxjs";
import { IUser } from "src/app/models/Identity/user";

@Component({
  selector: "app-user-input-searcher",
  templateUrl: "./user-input-searcher.component.html",
})
export class UserInputSearcherComponent implements OnChanges {
  @Input()
  userList: IUser[] = [];
  @Input() selectedUser: IUser | null = null;
  @Input()
  label?: string;
  @Input()
  keyForId: string = "-";
  @Input()
  defaultValue: IUser | null = null;
  @Output() selectedUserEmitter = new EventEmitter<IUser | null>();
  @Input() presetUser?: any;
  @Input() presetId?: number | string;
  @Input() useFloating: boolean = true;

  // search ngTypeAhead
  @ViewChild("instance", { static: true })
  instance?: NgbTypeahead;

  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  public searchUserForm: FormGroup = this.formBuilder.group({
    user: [this.defaultValue ?? null],
  });

  constructor(private formBuilder: FormBuilder) {}
  ngOnChanges(changes: SimpleChanges): void {
    const ctrl = this.searchUserForm?.get("user");
    if (!ctrl) {
      return;
    }

    if (changes["selectedUser"]) {
      ctrl.setValue(this.selectedUser ?? null, { emitEvent: false });
    }

    const listReady = Array.isArray(this.userList) && this.userList.length > 0;

    let userToSet: any | null = null;

    if (changes["presetUser"]?.currentValue !== undefined) {
      userToSet = this.presetUser ?? null;
    } else if (
      (changes["presetId"] || changes["userList"]) &&
      this.presetId != null &&
      listReady
    ) {
      userToSet =
        this.userList.find(
          u => String((u as any).id) === String(this.presetId)
        ) || null;
    }

    if (userToSet) {
      ctrl.setValue(userToSet, { emitEvent: false });
      this.selectedUserEmitter.emit(userToSet);
    }
  }

  onTyping(event: any) {
    const value = event.target.value;

    if (!value) {
      this.selectedUserEmitter.emit(null);
      return;
    }

    this.selectedUserEmitter.emit(null);
  }

  onInputClick() {
    const ctrl = this.searchUserForm.get("user");

    if (ctrl?.value && typeof ctrl.value === "object") {
      ctrl.setValue("", { emitEvent: false });

      this.selectedUserEmitter.emit(null);
    }

    this.click$.next("");
  }

  // formatter = (user: IUser) => user.name;
  formatter = (user: IUser | null) => user?.name ?? "";

  search: OperatorFunction<string, IUser[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    );
    const clicksWithClosedPopup$ = this.click$.pipe(
      filter(() => !this.instance?.isPopupOpen())
    );
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term =>
        (term === ""
          ? this.userList
          : this.userList.filter(
              v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1
            )
        ).slice(0, 10)
      )
    );
  };

  onSelect(item: IUser) {
    this.selectedUserEmitter.emit(item);
  }
  onBlur() {
    const currentFormValue = this.searchUserForm.get("user")?.value;
    if (!currentFormValue || currentFormValue === "") {
      this.selectedUserEmitter.emit(null);
    }
  }
}
